import * as React from 'react'
import { connect } from 'react-redux'
import {
    CardBody,
    Row,
    CardHeader,
    Col,
    Collapse,
    Input,
    Label, Form, FormGroup
} from "reactstrap";
import {WithTranslation, withTranslation} from "react-i18next";
import {CurrencyProps, LinkType, RENT_MONTHS, URL_AVESCORENT} from "App/constants";
import {basketRentSelectionChange} from "App/basket";
import {CurrentConfigurationRent} from "App/services/api";
import {Element} from "react-scroll";

interface StateToProps extends CurrencyProps {
    rent: CurrentConfigurationRent | undefined
}

interface DispatchToProps {
    onSelectRent: (selected: boolean, durationmonths: number|undefined) => void
}

const mapDispatchToProps = (dispatch: any) : DispatchToProps => ({
    onSelectRent: (selected: boolean, durationmonths: number|undefined) => dispatch(basketRentSelectionChange(selected, durationmonths))
});

interface ComponentState {
    isVisible: boolean
}

function initialState (props: StateToProps): ComponentState {
    return {
        isVisible: !!props.rent
    }
}

class _Component extends React.PureComponent<StateToProps & DispatchToProps & WithTranslation, ComponentState> {

    constructor(props: StateToProps & DispatchToProps & WithTranslation, context: any) {
        super(props, context);
        this.state = initialState(props);
    }

    toggleVisibility() {
        this.setState((state, props) => ({
            isVisible: !state.isVisible
        }));
    }

    render() {
        const {currency, t, onSelectRent, rent} = this.props;
        const rentDuration: number | undefined = rent&&rent.durationmonths||RENT_MONTHS[0];

        return <Element name={LinkType.RENT_SECTION}>
            <CardHeader className="px-5 d-flex align-items-center py-3 bg-white toggable" onClick={() => this.toggleVisibility()}>
                <span className="m-0 w-75 float-left title-normal-uppercase">{ t('products.configuration.rent')}</span>
                <i className={'far fa-lg w-25 text-right ' + (this.state.isVisible? 'fa-chevron-up' : 'fa-chevron-down')}></i>
            </CardHeader>
            <Collapse isOpen={this.state.isVisible}>
                <CardBody className="px-5 pt-2 pb-3 bodyslice">
                    <Row className="no-gutters">
                        <Col className="align-items-center py-2 pr-0 col-sm-8">
                            <div className="form-check">
                                <Input type="checkbox" checked={!!rent} id={"optionInputRent"} name={"optionInputRent"} className="align-middle"
                                       onChange={(e) => onSelectRent(e.target.checked,rentDuration)}/>
                                <Label htmlFor={"optionInputRent"} className="py-0 text-normal-details light align-middle">{ t('products.configuration.createrent')}</Label>
                            </div>
                        </Col>
                        <Col className="align-items-center py-2 pl-0 col-sm-4 text-right">
                            <Label className="pl-2 py-0 text-normal-details light align-middle">{rent&&rent.monthlyrate?t('products.configuration.rentprice', {amount:rent.monthlyrate, unit:currency}):null}</Label>
                        </Col>
                    </Row>
                    <Row className="no-gutters">
                        <Col className="align-items-center pr-0">
                            <Form inline>
                                <FormGroup>
                                    <Label for="rentDuration" className={"text-normal-details light pl-5"}>{ t('products.configuration.rentduration')}</Label>
                                    <Input type="select" name="rentDuration" id="rentDuration" className={"text-select-details light ml-3"} disabled={!rent}
                                           value={rentDuration}
                                           onChange={(e) => onSelectRent(true, Number(e.target.value))}>
                                        {
                                            RENT_MONTHS.map((month:number, index: number) => (
                                                <option key={month} value={month}>{t('products.configuration.rentmonth', {month: month})}</option>
                                            ))
                                        }
                                    </Input>
                                </FormGroup>
                                <Label className={"pl-3"}>{t('products.configuration.rentinfo')}<a href={URL_AVESCORENT} className="action pl-1">{t('products.configuration.avescorent')}</a></Label>
                            </Form>
                        </Col>
                    </Row>
                </CardBody>
            </Collapse>
        </Element>
    }
}

export const Component = connect(null, mapDispatchToProps)(withTranslation('common')(_Component));


// WEBPACK FOOTER //
// ./src/components/RentConf.tsx